export default {
  STORAGE_SAVED_LANGUAGE: 'FXM_USER_LANGUAGE',
  SET_LANGUAGE_LIST: 'SET_LANGUAGE_LIST',
  SET_LANGUAGE: 'SET_LANGUAGE',
  SET_TRANSLATIONS: 'SET_TRANSLATIONS',
  SET_FALLBACK: 'SET_FALLBACK_TRANSLATIONS',
  SET_PRIVACY_TRANSLATED: 'SET_PRIVACY_TRANSLATED',
  SET_PRIVACY_FALLBACK: 'SET_PRIVACY_FALLBACK'
};
